import React, { Component } from 'react';
import SupportTeam from './SupportTeam'; 
import { PageHeader } from '../components/shared/PageHeader';

export class SODashboard extends Component {
    static renderSODashboardTable(soDashboard) {
        return (
            <table className='table'>
                <thead>
                    <tr>
                        <th>Customer Code</th>
                        <th>Customer Name</th>
                        <th>Date</th>
                        <th>Time</th>
                        <th>SO Number</th>
                    </tr>
                </thead>
                <tbody>
                    {soDashboard.map(soDashboardItem =>
                        (<tr key={soDashboardItem.storeId}>
                            <td>{soDashboardItem.store_PPro_Customer_Code}</td>
                            <td>{soDashboardItem.store_Name}</td>
                            <td />
                            <td>{soDashboardItem.sO_Date}</td>
                            <td>{soDashboardItem.sO_Number}</td>
                        </tr>)
                    )}
                </tbody>
            </table>
        );
    }

    displayName = SODashboard.name

    constructor(props) {
        super(props);
        this.state = {
            isAdmin: false,
            soDashboard: [],
            loading: true };

        const fetchConfig = {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        };
        fetch('api/SalesOrder/dashboard', fetchConfig)
            .then(response => response.json())
            .then(data => {
                this.setState({ soDashboard: data, loading: false });
            })
            .catch(err => { }); // TODO - improve this experience
    }

    render() {
        let contents = this.state.loading
            ? <p style={{ padding: '10px' }}><em>Loading...</em></p>
            : SODashboard.renderSODashboardTable(this.state.soDashboard);

        return (
            <div>
                <PageHeader pageTitle="Sales Order Dashboard" />
                {contents}
                <SupportTeam isEditHome={false} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/SODashboard.js